import NInput from './NInput';
// import NInputPrefix from './NInputPrefix.vue';
// import NInputSuffix from './NInputSuffix.vue';

// export {
//     NInput,
//     NInputPrefix,
//     NInputSuffix
// };

export default NInput;